import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, map } from 'rxjs';
import { Extension } from 'src/app/models/centrex/extension';
import { OrganizationsService } from '../organizations.service';
import { ServiceBase } from '../service-base';
import { UsersService } from '../users.service';

@Injectable({
    providedIn: 'root',
})
export class ExtensionService extends ServiceBase {
    constructor(private http: HttpClient, private organizationsServices: OrganizationsService, private usersService: UsersService) {
        super();
    }

    getExtensions(): Observable<Extension[]> {
        const httpOptions = {
            headers: new HttpHeaders()
                .set('X-OrganizationId', this.organizationsServices.getCurrentOrganization().id ?? '')
                .set('X-UserId', this.usersService.getSessionCurrentUser().id ?? ''),
        };

        return this.http.get<Extension[]>(`${this.baseUrl}/api/extensions`, httpOptions).pipe(map((x) => Extension.createArray(x)));
    }

    getExtension(extensionId: string): Observable<Extension> {
        const httpOptions = {
            headers: new HttpHeaders()
                .set('X-OrganizationId', this.organizationsServices.getCurrentOrganization().id ?? '')
                .set('X-UserId', this.usersService.getSessionCurrentUser().id ?? ''),
        };

        return this.http.get<Extension>(`${this.baseUrl}/api/extensions/${extensionId}`, httpOptions);
    }

    addExtension(extension: Extension, globalNotification = true): Observable<Extension> {
        const httpOptions = {
            headers: new HttpHeaders()
                .set('Content-Type', 'application/json')
                .set('global-notification', String(globalNotification))
                .set('X-OrganizationId', this.organizationsServices.getCurrentOrganization().id ?? '')
                .set('X-UserId', this.usersService.getSessionCurrentUser().id ?? ''),
        };

        return this.http.post<Extension>(`${this.baseUrl}/api/extensions`, extension, httpOptions);
    }

    updateExtension(extension: Extension): Observable<Extension> {
        const httpOptions = {
            headers: new HttpHeaders()
                .set('Content-Type', 'application/json')
                .set('X-OrganizationId', this.organizationsServices.getCurrentOrganization().id ?? '')
                .set('X-UserId', this.usersService.getSessionCurrentUser().id ?? ''),
        };

        return this.http.patch<Extension>(`${this.baseUrl}/api/extensions/${extension.id}`, extension, httpOptions);
    }

    deleteExtension(extensionId: string) {
        const httpOptions = {
            headers: new HttpHeaders()
                .set('X-OrganizationId', this.organizationsServices.getCurrentOrganization().id ?? '')
                .set('X-UserId', this.usersService.getSessionCurrentUser().id ?? ''),
        };

        return this.http.delete<Extension>(`${this.baseUrl}/api/extensions/${extensionId}`, httpOptions);
    }
}
